/* eslint-disable */

import { sortAsc } from './sort-util'

const addOption = (selectElId, options, optionKey) => {
    options.forEach(v => {
        let selectEl = document.getElementById(selectElId);
        let optionEl = document.createElement('option');
        optionEl.text = v[optionKey];
        optionEl.value = v[optionKey];
        selectEl.add(optionEl);
    })
}

const addCheckbox = (wrapperId, options, eventHandler) => {
    options.forEach(v => {
        let wrapperEl = document.getElementById(wrapperId);
        let checkboxWrapper = document.createElement('div');
        let checkboxEl = document.createElement('input');
        let labelEl = document.createElement('label');
        checkboxWrapper.classList.add('checkbox-wrapper');
        checkboxEl.type = 'checkbox';
        checkboxEl.id = v.name;
        checkboxEl.name = v.name;
        checkboxEl.value = v.name;
        checkboxEl.checked = 'checxked';
        checkboxEl.setAttribute('data-timeframe', 'past');
        if (eventHandler) {
            checkboxEl.addEventListener('input', eventHandler);
        }
        labelEl.setAttribute('for', v.name);
        labelEl.innerText = v.name;
        checkboxWrapper.appendChild(checkboxEl);
        checkboxWrapper.appendChild(labelEl);
        wrapperEl.appendChild(checkboxWrapper);
    })
}

const createPublicationEl = (data, index, openModal) => {
    const publicationEl = document.createElement('div');
    publicationEl.classList.add('publication');
    publicationEl.setAttribute('data-publication-title', data.title);
    publicationEl.setAttribute('data-publication-index', index);
    publicationEl.setAttribute('tabindex', "-1");
    index < 5 ? publicationEl.hidden = false : publicationEl.hidden = true;
    const innerHtml = `
        <div class="publication__column-1">
            <div class="publication__date">
                <p><strong>${data.date}</strong></p>
            </div>
        </div>
        <div class="publication__column-2">
            <div class="publication__title dark-blue-text">
                <h3><strong>${data.title}</strong></h3>
            </div>
            <div class="publication__category">
                <p><strong>${data.category}</strong></p>
            </div>
            <div class="publication__citation">
                ${data.citation}
            </div>
            <div class="publication__description">
                <p>${data.description}</p>
            </div>
        </div>
        <div class="publication__column-3">
            <div class="publication__url">
                <a href="${data.url}" rel="noopener" target="_blank" ${openModal ? `data-component="modal" data-target="exit-modal" data-modal-group="${index}" data-initialized="true" data-state="closed" data-create-close-button="false"` : ""}><strong>Access Publication</strong></a>
            </div>
        </div>
    `
    publicationEl.innerHTML = innerHtml;
    return publicationEl;
}

const createCongressEl = (data, index) => {
    const congressEl = document.createElement('div');
    congressEl.classList.add('congress');
    congressEl.classList.add(`congress--${data.timeframe}`);
    congressEl.setAttribute('data-congress-name', data.name);
    congressEl.setAttribute('data-congress-index', index);
    congressEl.setAttribute('tabindex', "-1");
    index < 5 ? congressEl.hidden = false : congressEl.hidden = true
    const innerHtml = `
        <div class="congress__column-1">
            <div class="congress__date">
                <p><strong>${data.date}</strong></p>
            </div>
        </div>
        <div class="congress__column-2">
            <div class="congress__name dark-blue-text">
                <h3>${data.name}</h3>
            </div>
            <div class="congress__location">
                <p>${data.location}</p>
            </div>
            <div class="congress__description">
                <p>${data.description !== undefined ? data.description : ''}</p>
            </div>
            <div class="congress__category">
                <p><strong>${data.category ? data.category : ''}</strong></p>
            </div>
            ${data.assets && data.timeframe === 'past' ? createAssetsEl(data.assets, data.timeframe, index) : ''}
        </div>
        <div class="congress__column-3">
            <div class="congress__website">
                <a href="${data.website}" rel="noopener" target="_blank" data-component="modal" data-target="exit-modal" data-modal-group="${index}" data-initialized="true" data-state="closed" data-create-close-button="false"><strong>View Congress Website</strong></a>
            </div>
        </div>
    `
    congressEl.innerHTML = innerHtml;
    return congressEl;
}

const createAssetsEl = (data, timeframe, index) => {
    const assetsWrapper = `
        <div class="assets-wrapper" data-component="accordion" data-accordion-group="${index}" data-initialized="true">
            <button id="asset-${timeframe}-${index}" aria-expanded="false" data-state="collapsed" data-index="${index}" data-trigger="" data-trigger-accordion="" data-accordion-group="${index}" aria-controls="panel-${timeframe}-${index}" class="accordion-group__trigger">
                <strong>View Resources</strong>
            </button>
            <div tabindex="-1" data-state="collapsed" data-index="${index}" data-panel="" data-panel-accordion="" data-accordion-group="${index}" id="panel-${timeframe}-${index}"> 
                <p class="assets-preheader dark-blue-text"><strong>Indivior Posters and Presentations</strong></p>
                ${createAsset(data)}
            </div>
        </div>
    `
    return assetsWrapper;
}

const createAsset = (data) => {
    return sortAsc(data).map(a => {
        const assetUrl = /indiviormedicalaffairs.com|klickcloud.net|cloudfront.net/.test(location.host) ? a.url.replace('dl.airtable.com', location.host) : a.url;
        return (`
            <div class="asset" data-title="${a.title}">
                <div class="asset__accent-image">
                    <img src="/assets/images/icons/icon-resource-${a.type === 'Poster' ? 'poster' : 'deck'}.svg" alt="" />
                </div>
                <div class="asset__info">
                    <a class="asset__title" href="${assetUrl}" rel="noopener" target="_blank">${a.title}</a>
                    <p class="asset__description">${a.description}</p>
                    <p class="asset__category" ${a.category === undefined ? "hidden" : ""}><b>${a.category !== undefined ? a.category : ""}</b></p>
                </div>
            </div>
        `);
    }).join('');
}

const clearHtml = (el) => {
    el.innerHTML = '';
}

const zeroResults = (data, selector, returnButtonSelector) => {
    if (data.length <= 0) {
        document.querySelector(selector).hidden = false;
        document.querySelector(returnButtonSelector).hidden = true;
    } else {
        document.querySelector(selector).hidden = true;
        document.querySelector(returnButtonSelector).hidden = false;
    }
}

const resultCounter = (counter, selector) => {
    document.querySelector(selector).innerText = counter.length;
}

const returnToSearch = (selector, target) => {
    document.querySelector(selector).addEventListener('click', e => {
        document.querySelector(target).focus();
    })
}

export {
    addOption,
    addCheckbox,
    createPublicationEl,
    createCongressEl,
    clearHtml,
    zeroResults,
    resultCounter,
    returnToSearch,
}
